import React from "react";
/** Components Import */

function Snackbar({
  snackbars,
  setSnackbars,
  time,
  containerStyle,
  messageStyle,
}) {
  React.useEffect(() => {
    CloseSnackbar();
  }, []);

  const CloseSnackbar = () => {
    setTimeout(() => {
      setSnackbars({
        ...snackbars,
        toggle: !snackbars.toggle,
      });
    }, time);
  };

  return (
    <div
      className={"snackbar-wrap snackbar-type-" + snackbars.type}
      style={containerStyle}
    >
      <div className="snackbar-message" style={messageStyle}>
        {snackbars.message}
      </div>
    </div>
  );
}

Snackbar.defaultProps = {
  time: 3000,
};

export default Snackbar;
